import { render, staticRenderFns } from "./SecurityServer.vue?vue&type=template&id=cbb4fd68&scoped=true&xmlns%3Ahttps=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./SecurityServer.vue?vue&type=script&lang=ts&"
export * from "./SecurityServer.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityServer.vue?vue&type=style&index=0&id=cbb4fd68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb4fd68",
  null
  
)

export default component.exports